import { render, staticRenderFns } from "./FormAddProcesos.vue?vue&type=template&id=740dc93e"
import script from "./FormAddProcesos.vue?vue&type=script&lang=js"
export * from "./FormAddProcesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports